import { render, staticRenderFns } from "./ProjectPlanningConfigModal.vue?vue&type=template&id=4c2b2263&scoped=true&"
import script from "./ProjectPlanningConfigModal.vue?vue&type=script&lang=js&"
export * from "./ProjectPlanningConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPlanningConfigModal.vue?vue&type=style&index=0&id=4c2b2263&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2b2263",
  null
  
)

export default component.exports